import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import { buildErrorMessageForName } from "@gettactic/helpers/src/hook-form/buildErrorMessageForName";
import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { RadioInput } from "./RadioInput";
import { HookFormRadioInputProps } from "./RadioInput.types";

/**
 * One option of a react-hook-form field: render one per option with the same `name`; selecting
 * it stores `radioValue`.
 */
export const HookFormRadioInput = <T extends FieldValues>(
  props: HookFormRadioInputProps<T>
): React.ReactElement => {
  const { form, name, rules, onChange, radioValue, ...rest } = props;

  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({
        form,
        name,
        rules,
        isRequired: props.isRequired
      })}
      render={({ field, fieldState }) => (
        <RadioInput
          {...rest}
          // The field name groups the radios for the browser: arrow keys and "1 of 3"
          name={name}
          value={radioValue}
          checked={field.value === radioValue}
          onChange={(checked) => {
            if (checked) {
              field.onChange(radioValue);
              onChange?.(checked);
            }
          }}
          error={
            fieldState.error?.message ||
            buildErrorMessageForName(form, name) ||
            undefined
          }
        />
      )}
    />
  );
};
